import { render, staticRenderFns } from "./shudiLeftOne.vue?vue&type=template&id=f08b8830"
import script from "./shudiLeftOne.vue?vue&type=script&lang=js"
export * from "./shudiLeftOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports